module.exports = __webpack_public_path__ + "files/21613b540e7357a57dcf43437c93a67f.png";